import tax from './../../../services/purchase/tax'

export default {
    namespaced: true,
    state: {
        list: [],
        loading: false
    },
    getters: {
        list: state => state.list,
        loading: state => state.loading
    },
    mutations: {
        setLoading: (state, payload) => state.loading = payload,
        setList: (state, payload) => state.list = payload
    },
    actions: {
        index(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit("setLoading", true);
                tax.index(payload).then(response => {
                    context.commit("setList", response.data);
                    resolve(response);
                }).catch(error => {
                    reject(error);
                }).finally(() => {
                    context.commit("setLoading", false);
                });
            });
        }
    }
}